import React from 'react';

//---------------------------------------
// 日付フォーマット
// 引数
//    date   [in] 日付でフォーマットされた値
//    format [in] フォーマットしたい形式(例　YYYY年MM月DD日)
// 戻値
//    format  : フォーマットされた日付の文字列
//---------------------------------------
export function formatDate(date, format) {
  if (!format) format = 'YYYY-MM-DD hh:mm:ss.SSS';
  format = format.replace(/YYYY/g, date.getFullYear());
  format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
  format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
  format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2));
  format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
  format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
  if (format.match(/S/g)) {
    var milliSeconds = ('00' + date.getMilliseconds()).slice(-3);
    var length = format.match(/S/g).length;
    for (var i = 0; i < length; i++) format = format.replace(/S/, milliSeconds.substring(i, i + 1));
  }
  return format;
}

export function hankaku2Zenkaku(str) {
  return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  });
}

export function toBoolean(data) {
  return data.toString().toLowerCase() === 'true';
}

export function getDayOfWeek(dateStr) {
  var date = new Date(dateStr);
  var dayOfWeekStr = ["日", "月", "火", "水", "木", "金", "土"][date.getDay()];

  return dayOfWeekStr;
}

//CHANGED ADD 2023/07/04 #17
export function blackOrWhite(hexcolor) {
  let r = parseInt(hexcolor.substring(1, 3), 16);
  let g = parseInt(hexcolor.substring(3, 5), 16);
  let b = parseInt(hexcolor.substring(5, 7), 16);

  return ((((r * 299) + (g * 587) + (b * 114)) / 1000) < 128) ? "white" : "black";
}


export function pNumFormatValue(input) {
  if (!input) return input; // null, undefined, 空文字などはそのまま返す

  // 「/」が付くの場合はそれぞれでフォーマットする
  if (input.includes('/')) {
    const [left, right] = input.split('/');
    const formattedLeft = isStrictNumber(parseFloat(left)) ? parseFloat(left).toFixed(2) : left;
    const formattedRight = isStrictNumber(parseFloat(right)) ? parseFloat(right).toFixed(2) : right;
    return `${formattedLeft}/${formattedRight}`;
  }

  // それ以外の場合はそのまま整形する
  return isStrictNumber(input) ? parseFloat(input).toFixed(2) : input;
}

export function pNumParseAndFormat(input) {
  const _input = input || "-";

  const data = _input
    .split("/")
    .map((d) => {
      const num = parseFloat(d);
      if (num === 0) return null;
      return num || d;
    })
    .filter((item) => item !== null)
    .map((value, i, arr) => {
      const v = isStrictNumber(value) ? parseFloat(value).toFixed(2) : value;
      const style = {
        width: `calc(100% / ${arr.length})`,
        backgroundColor: "white",
        color: "black",
        border: "1px solid black",
        fontSize: "0.75rem",
        fontWeight: "bold",
      };
      return <div key={i} style={style}>{v}</div>;
    });

  return (
    <div
      style={{ paddingLeft: "1px", paddingRight: "1px", gap: "1px" }}
      className="d-flex justify-content-around"
    >
      {data}
    </div>
  );
}

export function pStrengthParseAndFormat(input, classArray) {
  const _input = input || "-";

  const data = _input.split("/").map((value, i, arr) => {
    const v = value ?? "";
    const classObj = classArray[i];
    const bgStyle =
      classObj &&
      classObj.bgColor1 &&
      classObj.bgColor2 &&
      classObj.bgColor1 !== classObj.bgColor2
        ? {
            backgroundSize: "auto auto",
            backgroundColor: classObj.bgColor1,
            backgroundImage:
              `repeating-linear-gradient(90deg, transparent, transparent 6px, ${classObj.bgColor2} 0px, ${classObj.bgColor2} 12px )`,
          }
        : {
            backgroundColor: classObj?.bgColor1 || "white",
          };

    const style = {
      ...bgStyle,
      // backgroundColor: classObj?.bgColor1 ?? "white",
      color: classObj?.textColor ?? "black",
      width: `calc(100% / ${arr.length})`,
      border: "1px solid black",
      fontWeight: "normal",
    };
    return <div key={i} style={style}>{v}</div>;
  });
  return (
    <div
      style={{ paddingLeft: "1px", paddingRight: "1px", gap: "1px" }}
      className="d-flex justify-content-around"
    >
      {data}
    </div>
  );
}

export function getPWeightSum(input1, input2) {
  if (!input1 && !input2) return 0;
  if (!input2) return input1;
  if (!input1) return input2;

  return parseFloat(input1) + parseFloat(input2);
}

export function getProductNumberBgColor(limitDate, currentDate) {
  const limit = new Date(limitDate);
  const current = new Date(currentDate);

  if (isNaN(limit.getTime()) || isNaN(current.getTime())) {
    return {
      backgroundColor: "white",
    }; // 日付が無効な場合
  }

  const diffTime = limit.getTime() - current.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays >= 8) {
    return {
      backgroundColor: "white",
    };
  } else if (diffDays >= 1) {
    return {
      backgroundColor: "yellow",
    };;
  } else {
    return {
      backgroundColor: "red",
      color: "white",
    };
  }
}

export function isSameDate(date1, date2) {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}

export function getPlimitResources(resources, pLimitArray) {
  // 打設期限の情報をResourcesに追記する
  pLimitArray.forEach((pl) => {
    const resourceIndex = resources
      .filter((r) => r.groupOnly)
      .findIndex((r) => r.id === pl.articleId);
    if (resourceIndex < 0) return;
    const currentData = {
      limitDate: pl.limitDate,
      code: pl.code,
      overCnt: pl.overCnt,
    };

    const prevArray = resources[resourceIndex]?.pLimitArray ?? [];
    const existingIndex = prevArray.findIndex(
      (item) => item.code === currentData.code
    );

    const addData =
      existingIndex !== -1
        ? [
            ...prevArray.slice(0, existingIndex),
            currentData,
            ...prevArray.slice(existingIndex + 1),
          ]
        : [...prevArray, currentData];
    resources[resourceIndex] = {
      ...resources[resourceIndex],
      pLimitArray: addData,
    };
  });

  return resources;
}

export function RowColInModal(input, isNum = false) {
  const _input = input || "-";

  const data = _input.split("/").map((value, i, arr) => {
    const num = isNum ? parseFloat(value): value;
    const v = isStrictNumber(num) ? parseFloat(num).toFixed(2) : value;
    const style = {
      width: `calc(100% / ${arr.length})`,
      backgroundColor: "white",
      color: "black",
      // border: "1px solid black",
      fontSize: "1rem",
      // fontWeight: "bold",
      backgroundColor: "#f7f7f7",
      padding: "5px",
    };
    return <div key={i} style={style}>{v}</div>;
  });

  return (
    <div
      style={{ paddingLeft: "1px", paddingRight: "1px", gap: "10px" }}
      className="d-flex justify-content-around"
    >
      {data}
    </div>
  );
}

const isStrictNumber = (value) => {
  if (typeof value === 'number') {
    return isFinite(value);
  }
  if (typeof value === 'string' && value.trim() !== '') {
    return !isNaN(Number(value));
  }
  return false;
}